module.exports = __webpack_public_path__ + "img/13_21.750a311b.png";